export const SECTION_SCROLL_OFFSET = -96;

export const SECTION_NAV_ITEMS = [
  { to: "home", label: "Home" },
  { to: "experiences", label: "Experience" },
  { to: "projects", label: "Projects" },
  { to: "academic", label: "Academics" },
  // { to: "contact", label: "Contact" },
];
